@if ({
  components: components$ | async,
  }; as content) {
  <div>
    <simple-toggle [checked]="areAllOpen" [label]="'common.toggleAll'" (callbackOnChange)="onToggleAll($event)"> </simple-toggle>
  </div>
  <div #container class="cms-collapse-container">
    <collapse-list
      [collapseList]="content.components || []"
      [isHtmlEditable]="true"
      (_onCloseItem)="handleToggle()"
      (_onOpenItem)="handleToggle()"
    ></collapse-list>
  </div>
}
